import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("common-dialog", {
    attrs: {
      "is-open": _vm.isOpen,
      "header-text": _vm.$t("workPackages.createNew"),
      "ok-btn-text": _vm.$t("actions.confirmCopy"),
      "ok-btn-disabled": !_vm.isValid,
    },
    on: { onOk: _vm.save, onCancel: _vm.cancel },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              VRow,
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  VCol,
                  { attrs: { cols: "12" } },
                  [
                    _c(VTextField, {
                      attrs: {
                        label: _vm.$t("workPackages.enterWorkpackageName"),
                        rules: [_vm.valueRequired],
                      },
                      model: {
                        value: _vm.workpackage.description,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.workpackage,
                            "description",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "workpackage.description",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              VRow,
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  VCol,
                  { attrs: { cols: "12" } },
                  [
                    _c("div", { staticClass: "section-label" }, [
                      _vm._v(_vm._s(_vm.$t("workPackages.sourceWorkpackage"))),
                    ]),
                    _vm._v(" "),
                    _c(VAutocomplete, {
                      attrs: {
                        items: _vm.sourceWorkpackages,
                        "item-text": "description",
                        "item-value": "_id",
                        rules: [_vm.valueRequired],
                      },
                      on: {
                        change: function ($event) {
                          return _vm.setAvailableHierarchiesAndStoreFormat(
                            $event
                          )
                        },
                      },
                      model: {
                        value: _vm.workpackage.workpackageId,
                        callback: function ($$v) {
                          _vm.$set(_vm.workpackage, "workpackageId", $$v)
                        },
                        expression: "workpackage.workpackageId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              VRow,
              [
                _c(
                  VCol,
                  { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                  [
                    _c(
                      VMenu,
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 5,
                          transition: "scale-transition",
                          "offset-y": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VTextField,
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "workPackages.completionDate"
                                        ),
                                        "append-icon": "event",
                                        readonly: "",
                                      },
                                      on: {
                                        "click:append": function ($event) {
                                          _vm.completionDatePicker = true
                                        },
                                      },
                                      model: {
                                        value: _vm.computedCompletionDate,
                                        callback: function ($$v) {
                                          _vm.computedCompletionDate = $$v
                                        },
                                        expression: "computedCompletionDate",
                                      },
                                    },
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.completionDatePicker,
                          callback: function ($$v) {
                            _vm.completionDatePicker = $$v
                          },
                          expression: "completionDatePicker",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c(VDatePicker, {
                          attrs: {
                            "first-day-of-week": _vm.firstDayOfWeek,
                            locale: _vm.locale,
                          },
                          on: {
                            input: function ($event) {
                              _vm.completionDatePicker = false
                            },
                          },
                          model: {
                            value: _vm.completionDate,
                            callback: function ($$v) {
                              _vm.completionDate = $$v
                            },
                            expression: "completionDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  VCol,
                  { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                  [
                    _c(
                      VMenu,
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 5,
                          transition: "scale-transition",
                          "offset-y": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VTextField,
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "workPackages.goLiveDate"
                                        ),
                                        "append-icon": "event",
                                        readonly: "",
                                      },
                                      on: {
                                        "click:append": function ($event) {
                                          _vm.goLiveDatePicker = true
                                        },
                                      },
                                      model: {
                                        value: _vm.computedGoLiveDate,
                                        callback: function ($$v) {
                                          _vm.computedGoLiveDate = $$v
                                        },
                                        expression: "computedGoLiveDate",
                                      },
                                    },
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.goLiveDatePicker,
                          callback: function ($$v) {
                            _vm.goLiveDatePicker = $$v
                          },
                          expression: "goLiveDatePicker",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c(VDatePicker, {
                          attrs: {
                            "first-day-of-week": _vm.firstDayOfWeek,
                            locale: _vm.locale,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onGoLiveDateInput()
                            },
                          },
                          model: {
                            value: _vm.goLiveDate,
                            callback: function ($$v) {
                              _vm.goLiveDate = $$v
                            },
                            expression: "goLiveDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "feature-toggle",
              { attrs: { toggle: "enableReferenceDate" } },
              [
                _c(
                  VRow,
                  [
                    _c(
                      VCol,
                      { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                      [
                        _c(
                          VMenu,
                          {
                            attrs: {
                              "close-on-content-click": false,
                              "nudge-right": 5,
                              transition: "scale-transition",
                              "offset-y": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      VTextField,
                                      _vm._g(
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "workPackages.referenceDate"
                                            ),
                                            "append-icon": "event",
                                            readonly: "",
                                          },
                                          on: {
                                            "click:append": function ($event) {
                                              _vm.referenceDatePicker = true
                                            },
                                          },
                                          model: {
                                            value: _vm.computedReferenceDate,
                                            callback: function ($$v) {
                                              _vm.computedReferenceDate = $$v
                                            },
                                            expression: "computedReferenceDate",
                                          },
                                        },
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.referenceDatePicker,
                              callback: function ($$v) {
                                _vm.referenceDatePicker = $$v
                              },
                              expression: "referenceDatePicker",
                            },
                          },
                          [
                            _vm._v(" "),
                            _c(VDatePicker, {
                              attrs: {
                                "first-day-of-week": _vm.firstDayOfWeek,
                                locale: _vm.locale,
                                min: _vm.sixMonthsAgo,
                                max: _vm.todaysDate,
                              },
                              on: {
                                input: function ($event) {
                                  _vm.referenceDatePicker = false
                                },
                              },
                              model: {
                                value: _vm.referenceDate,
                                callback: function ($$v) {
                                  _vm.referenceDate = $$v
                                },
                                expression: "referenceDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.creationHierarchyLevel === _vm.pricingGroupLevel &&
            _vm.availablePricingGroups.length > 0
              ? _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        _c("div", { staticClass: "section-label" }, [
                          _vm._v(_vm._s(_vm.$t("pricing.pricingGroup"))),
                        ]),
                        _vm._v(" "),
                        _c(VAutocomplete, {
                          attrs: {
                            items: _vm.availablePricingGroups,
                            "item-text": "levelEntryDescription",
                            "item-value": "levelEntryKey",
                            multiple: "",
                            chips: "",
                            "small-chips": "",
                            "deletable-chips": "",
                          },
                          model: {
                            value: _vm.workpackage.hierarchyIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.workpackage, "hierarchyIds", $$v)
                            },
                            expression: "workpackage.hierarchyIds",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.creationHierarchyLevel === _vm.categoryLevel &&
            _vm.availableCategories.length > 0
              ? _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      {
                        staticClass: "category-selection",
                        attrs: { cols: "12" },
                      },
                      [
                        _c("div", { staticClass: "section-label" }, [
                          _vm._v(_vm._s(_vm.$t("workPackages.categories"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          VExpansionPanels,
                          _vm._l(_vm.availableCategories, function (category) {
                            return _c(
                              VExpansionPanel,
                              { key: category._id },
                              [
                                _c(VExpansionPanelHeader, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between align-center w-100",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-description" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              category.levelEntryDescription
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(VCheckbox, {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          "input-value":
                                            _vm.isUnitAllSelected(category),
                                          indeterminate:
                                            _vm.isUnitIndeterminate(category),
                                          disabled:
                                            _vm.getCategoriesForUnit(category)
                                              .length === 0,
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                          change: function ($event) {
                                            return _vm.toggleAllCategoriesForUnit(
                                              category._id,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(VExpansionPanelContent, [
                                  _c(
                                    "div",
                                    { staticClass: "category-items" },
                                    _vm._l(
                                      _vm.getCategoriesForUnit(category),
                                      function (subcategory) {
                                        return _c(
                                          "div",
                                          {
                                            key: subcategory.levelEntryKey,
                                            staticClass:
                                              "d-flex justify-space-between align-center py-1",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "category-description",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      subcategory.levelEntryDescription
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(VCheckbox, {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                value:
                                                  subcategory.levelEntryKey,
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedHierarchies[
                                                    category._id
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedHierarchies,
                                                    category._id,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedHierarchies[category._id]",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "feature-toggle",
              { attrs: { toggle: "enableWorkpackagePeriodTypes" } },
              [
                _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "6" } },
                      [
                        _c(VSelect, {
                          attrs: {
                            items: _vm.workpackagePeriodTypeItems,
                            label: `${_vm.$t(
                              "workPackages.workpackagePeriodType"
                            )} *`,
                            rules: [_vm.valueRequired],
                            "item-text": "text",
                            "item-value": "value",
                          },
                          model: {
                            value: _vm.workpackagePeriodType,
                            callback: function ($$v) {
                              _vm.workpackagePeriodType = $$v
                            },
                            expression: "workpackagePeriodType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "feature-toggle",
              { attrs: { toggle: "enableAOExtracts" } },
              [
                _c(
                  VRow,
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        _c("div", { staticClass: "section-label" }, [
                          _vm._v(_vm._s(_vm.$t("workPackages.aoExtracts"))),
                        ]),
                        _vm._v(" "),
                        _c(VAutocomplete, {
                          attrs: {
                            items: _vm.aoExtractsOptions,
                            multiple: "",
                            chips: "",
                            "small-chips": "",
                            "deletable-chips": "",
                            dense: "",
                            "item-text": "displayName",
                            "item-value": "auditCorrelationId",
                            rules: [_vm.aoExtractsRules],
                          },
                          model: {
                            value: _vm.selectedAOExtracts,
                            callback: function ($$v) {
                              _vm.selectedAOExtracts = $$v
                            },
                            expression: "selectedAOExtracts",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "feature-toggle",
                          { attrs: { toggle: "usePeriodIdsInAOExtracts" } },
                          [
                            _vm.selectedAOExtracts.length > 0
                              ? [
                                  _c("div", { staticClass: "mb-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "workPackages.associatedPeriodIds"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.getAssociatedPeriodIdsText)
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("optimise-prices-toggle"),
            _vm._v(" "),
            _c("refresh-on-create-toggle"),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }